<template>
  <div class="relative">
    <img :src="avatarSrc" :alt="avatarAlt" :class="avatarClasses" />
    <div
      class="absolute left-0 top-0 z-10 h-full w-full rounded-full ring-1 ring-inset ring-white/10"
    />
    <BadgeIcon :badge-number="rank" :width="badgeSize" :height="badgeSize" :class="badgeClasses" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BadgeIcon } from '@/components/icons'
import defaultProfileImage from '@/assets/profile_image.png'

interface AvatarWithRankProps {
  avatarSrc?: string
  rank?: number
  size?: 'sm' | 'md' | 'lg' | 'xl'
  avatarAlt?: string
  badgePosition?: 'bottom-right' | 'bottom-center' | 'top-right'
}

const props = withDefaults(defineProps<AvatarWithRankProps>(), {
  rank: 0,
  size: 'md',
  avatarAlt: 'Profile avatar',
  badgePosition: 'bottom-center'
})

const sizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-11 w-11',
  lg: 'h-16 w-16',
  xl: 'h-20 w-20'
}

const badgeSizes = {
  sm: '12',
  md: '16',
  lg: '20',
  xl: '24'
}

const badgePositionClasses = {
  'bottom-right': 'absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4',
  'bottom-center': 'absolute bottom-0 right-1/2 translate-x-1/2 translate-y-1/2',
  'top-right': 'absolute top-0 right-0 translate-x-1/4 -translate-y-1/4'
}

const avatarSrc = computed(() => props.avatarSrc || defaultProfileImage)

const avatarClasses = computed(() => ['rounded-full', sizeClasses[props.size]])

const badgeSize = computed(() => badgeSizes[props.size])

const badgeClasses = computed(() => badgePositionClasses[props.badgePosition])
</script>

<style scoped></style>
